export default {
  'sidebar.button.settings': 'Einstellungen',

  'button.save.feed': 'Speichern',
};
